var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBanWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ban--white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-ban",
    transform: "translate(0.250000, 0.250000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,2.28125 C3.77083333,0.760416667 5.60416667,0 7.75,0 C9.89583333,0 11.7239583,0.755208333 13.234375,2.265625 C14.7447917,3.77604167 15.5,5.60416667 15.5,7.75 C15.5,9.89583333 14.7447917,11.7239583 13.234375,13.234375 C11.7239583,14.7447917 9.89583333,15.5 7.75,15.5 C5.60416667,15.5 3.77604167,14.7447917 2.265625,13.234375 C0.755208333,11.7239583 0,9.89583333 0,7.75 C0,5.60416667 0.75,3.78125 2.25,2.28125 Z M14,7.4375 C13.9166667,5.83333333 13.3072917,4.46354167 12.171875,3.328125 C11.0364583,2.19270833 9.671875,1.58333333 8.078125,1.5 C6.484375,1.41666667 5.09375,1.86458333 3.90625,2.84375 L12.65625,11.59375 C13.6354167,10.40625 14.0833333,9.02083333 14,7.4375 Z M1.5,8.09375 C1.58333333,9.67708333 2.19270833,11.0364583 3.328125,12.171875 C4.46354167,13.3072917 5.828125,13.9166667 7.421875,14 C9.015625,14.0833333 10.40625,13.6354167 11.59375,12.65625 L2.84375,3.90625 C1.86458333,5.09375 1.41666667,6.48958333 1.5,8.09375 Z",
    id: "\\uF05E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBanWhite);
export default __webpack_public_path__ + "static/media/icon-ban--white.faa759a9d3495ddd4900d4cf0643c0e7.svg";
export { ForwardRef as ReactComponent };